import styled, { css } from 'styled-components';

/* istanbul ignore next */
const getAspectRatioByLocale = (locale: string) => {
  switch (locale) {
    case 'ar':
    case 'es-mx':
    case 'hi':
    case 'id':
    case 'nl':
    case 'no':
    case 'pt':
    case 'sv':
      return '27/8';
    case 'en':
      return '323/96';
    default:
      return '300/89';
  }
};

export const GooglePlayBadge = styled.div<{
  $image: string;
  $locale: string;
}>(
  ({ $image, $locale }) => css`
    height: 100%;
    aspect-ratio: ${getAspectRatioByLocale($locale)};
    background-image: url(${$image});
    background-position-x: left;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: contain;
    /* Hides the text */
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  `,
);

export const GooglePlayBadgeWrapper = styled.a(
  ({ theme }) => css`
    width: fit-content;
    height: ${theme.sz.s14};
    display: block;
    overflow: hidden;
  `,
);
